import { getContextualRequest, normalizeUPApiError } from '../../../../modules/utils/index.js';
export async function fetchProductByRatePlan(client, { ratePlanCode }) {
    try {
        const req = await getContextualRequest(client);
        const res = await req.get(`${client.context.api.host}/subscriptions/product/by_rate_plan/${ratePlanCode}`);
        return res.body;
    }
    catch (error) {
        throw normalizeUPApiError(error);
    }
}
